import { IHolding } from "../../holding"
import { arrayMax, arrayMin, range } from "../../utils/array"
import { AppSession } from "../appSession"
import { IAppDefinition } from "../types"

interface Config {
    firstYear: number
}

/** @internal */
export class ConnectionSyncConfig {

    private _firstYearInit: number

    years: number[]
    firstYear: number

    constructor(
        public readonly provider: IAppDefinition,
        public readonly holding: IHolding,
        public readonly session: AppSession) {


        const config: Config = session.getConfig() as Config

        const years = holding.CropYears.map(i => i.YearId)

        const lastYear = arrayMax(years, y => y)
        const firstYear = arrayMin(years, y => y)

        this.years = range(1 + lastYear - 2010).map(i => 2010 + i).reverse()
        this._firstYearInit = (config ? config.firstYear : null)
        this.firstYear = this._firstYearInit || firstYear

    }

    getConfig() {
        return {
            firstYear: this.firstYear
        }
    }

    hasChanged() {
        return this._firstYearInit != this.firstYear
    }

}
